import { useLanguage } from "@/lib/i18n";
import { LanguageToggle } from "@/components/LanguageToggle";

export default function Landing() {
  const { t } = useLanguage();
  return (
    <>
      <div
        className="fixed z-50"
        style={{
          top: "max(0.75rem, env(safe-area-inset-top))",
          right: "max(0.75rem, env(safe-area-inset-right))",
        }}
      >
        <LanguageToggle />
      </div>
      <main
        className="min-h-full flex items-center justify-center px-5 py-8"
        style={{
          paddingTop: "max(2rem, env(safe-area-inset-top))",
          paddingBottom: "max(2rem, env(safe-area-inset-bottom))",
        }}
      >
        <div className="text-center max-w-sm">
          <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">
            Hernandez Park
          </h1>
          <p className="mt-4 text-muted-foreground text-sm">
            {t.landingDescription}
          </p>
        </div>
      </main>
    </>
  );
}
